import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatNumberWithDotAndComma } from "@/utils/moneyFormatter";
import Call from "./Call";
import Collect from "./Collect";

interface CardProps {
  collectionOrder: CollectionOrder;
  collectionDate: string;
  onCollect: () => void;
}

export default function CollectionOrderCard({
  collectionOrder,
  collectionDate,
  onCollect,
}: CardProps) {
  const { Customer, location, date, id, amount, status } = collectionOrder;

  return (
    <Card className="w-full   p-0  shadow-2xl  shadow-[#969696]/20">
      <CardHeader className="flex flex-row items-center justify-between p-3 space-y-0 ">
        <CardTitle className="text-base font-semibold   w-[50%] truncate">
          {Customer?.commercial_name}
        </CardTitle>

        <div className="flex gap-2 ">
          <Badge
            variant={
              status !== undefined || status !== null ? status : "default"
            }
            className="text-[8px] font-medium "
          >
            {status}
          </Badge>

          <Collect collection={collectionOrder} onCollect={onCollect} />
        </div>
      </CardHeader>
      <CardContent className="flex p-3 -mt-2">
        <div className="flex flex-col w-3/4 ">
          <div className="text-xs  text-[#848382]">
            ID{id} • 'Amount':
            <span className="ml-1 font-semibold text-blue-600">
              {formatNumberWithDotAndComma(amount.toString())}
            </span>
          </div>

          <div className="flex gap-2">
            <div className="w-[40%] flex gap-1 items-center text-xs text-[#848382] mt-1">
              <img src="/assets/icons/location.svg" alt="location" />
              <a
                className="text-primary underline truncate"
                href={`https://www.google.com/maps?q=${location}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {location || "N/A"}
              </a>
            </div>

            <div className="w-[60%] flex gap-1 items-center text-xs text-[#848382] mt-1">
              <img src="/assets/icons/calendar.svg" alt="calendar" />

              <p className="underline truncate">
                {collectionDate.split("T")[0]}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end w-1/4 gap-1 ">
          {/* <Button className='bg-[#DD1144] rounded-[11px] p-0 w-[35px] h-[35px] '>
            <img src='/assets/icons/note.svg' alt='note' />
          </Button> */}
          <Call customer={Customer} />
        </div>
      </CardContent>
    </Card>
  );
}
